import { render, staticRenderFns } from "./SimpleSelect.vue?vue&type=template&id=bb08314a"
import script from "./SimpleSelect.js?vue&type=script&lang=js&external"
export * from "./SimpleSelect.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports